module.exports = __webpack_public_path__ + "media/images/pic/kid-503efca1d4a2245c5954053d39228159.jpeg";